import { defineMessages } from "react-intl";

const baseId = "t.pages.Welcome.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "WELCOME",
  },
  panelTitleConsultation: {
    id: baseId + "panelTitleConsultation",
    defaultMessage: "Consultation",
  },
  panelTitleManagementEntitlement: {
    id: baseId + "panelTitleManagementEntitlement",
    defaultMessage: "Management Entitlements",
  },
  panelTitleOther: {
    id: baseId + "panelTitleOther",
    defaultMessage: "Other",
  },
  panelTitleBr: {
    id: baseId + "panelTitleBr",
    defaultMessage: "Business Roles",
  },
  panelTitlePwd: {
    id: baseId + "panelTitlePwd",
    defaultMessage: "Password Management",
  },
  panelTitleCertification: {
    id: baseId + "panelTitleCertification",
    defaultMessage: "Certification",
  },
  panelTitleProfile: {
    id: baseId + "panelTitleProfile",
    defaultMessage: "Profile Management",
  },
  requestHistory: {
    id: baseId + "list.requestHistory",
    defaultMessage: "HISTORY REQUEST",
  },
  approvals: {
    id: baseId + "list.approvals",
    defaultMessage: "APPROVALS",
  },
  task: {
    id: baseId + "list.task",
    defaultMessage: "TASK",
  },
  abilitationRequest: {
    id: baseId + "list.abilitationRequest",
    defaultMessage: "ABILITATION REQUEST",
  },
  manuals: {
    id: baseId + "list.manuals",
    defaultMessage: "MANUALS",
  },
  externalPortal: {
    id: baseId + "list.externalPortal",
    defaultMessage: "EXTERNAL PORTAL",
  },
  catalog: {
    id: baseId + "list.catalog",
    defaultMessage: "CATALOG",
  },
  delegates: {
    id: baseId + "list.delegates",
    defaultMessage: "DELEGATES",
  },
  users: {
    id: baseId + "list.usersReference",
    defaultMessage: "USERS REFERENCE",
  },
  emergencyUsers: {
    id: baseId + "list.emergencyUsers",
    defaultMessage: "EMERGENCY USERS",
  },
  entitlementReference: {
    id: baseId + "list.entitlementReference",
    defaultMessage: "ENTITLEMENT REFERENCE",
  },
  userEntitlements: {
    id: baseId + "list.userEntitlements",
    defaultMessage: "USER ENTITLEMENTS",
  },
  userEntitlementDesc: {
    id: baseId + "list.desc.userEntitlementDesc",
    defaultMessage: "USER ENTITLEMENTS",
  },
  br: {
    id: baseId + "list.br",
    defaultMessage: "BUSINESS ROLES MANAGEMENT",
  },
  resetPassword: {
    id: baseId + "list.resetPassword",
    defaultMessage: "PASSWORD RESET",
  },
  changePassword: {
    id: baseId + "list.changePassword",
    defaultMessage: "CHANGE PASSWORD",
  },
  serviceRequest: {
    id: baseId + "list.serviceRequest",
    defaultMessage: "SERVICE REQUEST",
  },
  recertification: {
    id: baseId + "list.recertification",
    defaultMessage: "RECERTIFICATION",
  },
  consoleAdmin: {
    id: baseId + "list.consoleAdmin",
    defaultMessage: "CONSOLE ADMIN",
  },
  consoleAdminDesc: {
    id: baseId + "list.desc.consoleAdminDesc",
    defaultMessage: "CONSOLE ADMIN",
  },
  createCertification: {
    id: baseId + "list.createCertification",
    defaultMessage: "CREATE CERTIFICATION",
  },
  temporaryAbilitations: {
    id: baseId + "list.temporaryAbilitations",
    defaultMessage: "TEMPORARY ABILITATIONS",
  },
  technicalUsers: {
    id: baseId + "list.technicalUsers",
    defaultMessage: "TECHNICAL USERS",
  },
  technicalUsersDesc: {
    id: baseId + "list.desc.technicalUsers",
    defaultMessage: "Some technical users description for the welcome card",
  },
  profileManagementTitle: {
    id: baseId + "list.profileManagement",
    defaultMessage: "PROFILE MANAGEMENT",
  },

  reports: {
    id: baseId + "list.reports",
    defaultMessage: "REPORTS",
  },

  createCertificationDesc: {
    id: baseId + "list.desc.createCertificationDesc",
    defaultMessage: "CREATE CERTIFICATION",
  },

  requestHistoryDesc: {
    id: baseId + "list.desc.requestHistory",
    defaultMessage: "HISTORY REQUEST",
  },
  approvalsDesc: {
    id: baseId + "list.desc.approvals",
    defaultMessage: "APPROVALS",
  },
  taskDesc: {
    id: baseId + "list.desc.task",
    defaultMessage: "TASK",
  },
  abilitationRequestDesc: {
    id: baseId + "list.desc.abilitationRequest",
    defaultMessage: "ABILITATION REQUEST",
  },
  catalogDesc: {
    id: baseId + "list.desc.catalog",
    defaultMessage: "CATALOG",
  },
  manualsDesc: {
    id: baseId + "list.desc.manuals",
    defaultMessage: "MANUALS",
  },
  externalPortalDesc: {
    id: baseId + "list.desc.externalPortal",
    defaultMessage: "EXTERNAL PORTAL",
  },
  delegatesDesc: {
    id: baseId + "list.desc.delegates",
    defaultMessage: "DELEGATES",
  },
  usersDesc: {
    id: baseId + "list.desc.usersReference",
    defaultMessage: "USERS REFERENCE",
  },
  emergencyUsersDesc: {
    id: baseId + "list.desc.emergencyUsers",
    defaultMessage: "EMERGENCY USERS",
  },

  temporaryAbilitationsDesc: {
    id: baseId + "list.desc.temporaryAbilitations",
    defaultMessage: "TEMPORARY ABILITATIONS",
  },
  entitlementReferenceDesc: {
    id: baseId + "list.desc.entitlementReferenceDesc",
    defaultMessage: "ENTITLEMENT REFERENCE",
  },
  brDesc: {
    id: baseId + "list.desc.br",
    defaultMessage: "BUSINESS ROLES MANAGEMENT",
  },
  resetPasswordDesc: {
    id: baseId + "list.desc.resetPasswordDesc",
    defaultMessage: "RESET PASSWORD",
  },
  changePasswordDesc: {
    id: baseId + "list.desc.changePasswordDesc",
    defaultMessage: "CHANGE PASSWORD",
  },
  recertificationDesc: {
    id: baseId + "list.desc.recertificationDesc",
    defaultMessage: "RECERTIFICATION",
  },
  serviceRequestDesc: {
    id: baseId + "list.desc.serviceRequestDesc",
    defaultMessage: "SERVICE REQUEST",
  },
  profileManagementDesc: {
    id: baseId + "list.desc.profileManagement",
    defaultMessage: "PROFILE MANAGEMENT",
  },
  reportsDesc: {
    id: baseId + "list.desc.reportsDesc",
    defaultMessage: "REPORTS",
  },
  notifyTitle: {
    id: baseId + "notifyTitle",
    defaultMessage: "notifyTitle",
  },
});
